module.exports = __webpack_public_path__ + "img/index5.805f4a81.png";